module.exports = "/images/pergamumAlto.svg?ef6ed8056ae3bc875b6ce7f436a5fc0b";